import { render, staticRenderFns } from "./ContaCorrente.vue?vue&type=template&id=65b7482c"
import script from "./ContaCorrente.vue?vue&type=script&lang=js"
export * from "./ContaCorrente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports